import { useState } from 'react';
import { Box, Divider } from '@mui/material';
import { useTranslation } from 'react-i18next';
import {
    SttBookingList,
    SttButtonCollect,
    SttDialog,
    SttSelectPForm,
} from '../../../sporttia/all';
import { formatPriceByLocale } from '../../../lib/utils';

type Booking = {
    booking?: {
        price?: number;
        priceShape?: {
            currency?: string;
        };
    };
};

type Props = {
    open: boolean;
    bookings: Booking[];
    onCollect: (paymentForm: string) => void;
    onClose: () => void;
};

export default function ModalCollectBatch({
    open,
    bookings,
    onCollect,
    onClose,
}: Props): React.ReactElement {
    const { t } = useTranslation();
    const [paymentForm, setPaymentForm] = useState<string>('');

    return (
        <SttDialog
            open={open}
            onClose={onClose}
            title={t('bookings')}
            buttons={[
                {
                    type: 'component',
                    component: (
                        <SttButtonCollect
                            onClick={() => onCollect(paymentForm)}
                        />
                    ),
                },
                {
                    type: 'close',
                    onClick: onClose,
                },
            ]}
            content={
                <div>
                    <SttBookingList
                        bookings={bookings as any}
                        onSelect={() => {}}
                    />
                    <Box pb={2}>
                        <Divider />
                    </Box>
                    <Box
                        display="flex"
                        justifyContent="flex-end"
                        pr={2}
                        style={{ fontSize: 16 }}
                    >
                        <span style={{ marginRight: 8 }}>{t('Total')}:</span>
                        <span>
                            {formatPriceByLocale(
                                bookings.reduce(
                                    (result, booking) =>
                                        result + (booking.booking?.price ?? 0),
                                    0,
                                ),
                                bookings[0]?.booking?.priceShape?.currency,
                            )}
                        </span>
                    </Box>
                    <Box width="50%">
                        <SttSelectPForm
                            defVal={paymentForm}
                            activePFs={[
                                '',
                                'PURSE',
                                'CASH',
                                'BANK',
                                'DATAFONO',
                                'RECEIPT',
                                'FREE',
                                'CASHDRO',
                            ]}
                            onChange={({ value }: { value: unknown }) =>
                                setPaymentForm(value as string)
                            }
                        />
                    </Box>
                </div>
            }
        />
    );
}
